<template>
  <v-container grid-list-lg fluid px-0 py-0 my-0 mx-0 fill-height>
    <v-layout row wrap modal__block>
      <span class="modal__close" @click="closeModal"></span>
      <v-flex xs12 modal__wrapper :class="{ isBlocked: !editMode }">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-layout form__row row wrap v-if="editMode">
            <v-flex xs12 text-left>
              <h1>{{ create ? $t('components.clients.faces.form.titleAdd') : $t('components.clients.faces.form.titleUpdate') }}</h1>
            </v-flex>
            <v-flex xs12 py-0>
              <v-divider />
            </v-flex>
          </v-layout>

          <v-layout form__row row wrap v-else>
            <v-flex xs12 text-left>
              <h1>Должностное лицо</h1>
            </v-flex>
            <v-flex xs12 py-0>
              <v-divider />
            </v-flex>
          </v-layout>

          <v-layout form__row row wrap>
            <v-flex xs4 v-if="!isCompanyIP">
              <v-autocomplete
                v-model="face.type"
                :items="facesTypes"
                :label="$t('components.clients.faces.table.typeFace')"
                item-text="name"
                item-value="value"
                :rules="rules.type"
                :error-messages="errorMessages.type"
                :disabled="packageMode && !editMode"
                required
              ></v-autocomplete>
            </v-flex>

            <v-flex xs4 vv-if="!isCompanyIP">
              <v-menu
                ref="assigned_at"
                v-model="assignedAt"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="assigned_at"
                    :label="$t('components.clients.faces.form.assignedAt')"
                    prepend-icon="event"
                    v-on="on"
                    v-on:blur="formatAssignedAt"
                    :rules="rules.assigned_at"
                    v-mask="'##.##.####'"
                    :disabled="packageMode && !editMode"
                    return-masked-value
                    required
                  ></v-text-field>
                </template>
                <v-date-picker
                  ref="picker"
                  v-model="face.assigned_at"
                  :max="new Date().toISOString().substr(0, 10)"
                  min="1900-01-01"
                  @change="saveAssignedAt"
                  llocale="ru-ru"
                  first-day-of-week="1"
                  no-title
                ></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs4 v-if="!isCompanyIP">
              <v-autocomplete
                v-model="face.assigned_to"
                :items="faceAssignedTo"
                :label="$t('components.clients.faces.form.assignedTo')"
                item-text="name"
                item-value="value"
                :rules="rules.rule"
                :disabled="packageMode && !editMode"
                required
              ></v-autocomplete>
            </v-flex>
          </v-layout>

          <v-layout form__row row wrap>
            <v-flex xs4 sm4 md4>
              <v-text-field
                v-model="face.surname"
                :label="$t('components.clients.faces.form.surname')"
                :rules="rules.surname"
                :disabled="packageMode && !editMode"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs4 sm4 md4>
              <v-text-field
                v-model="face.name"
                :label="$t('components.clients.faces.form.name')"
                :rules="rules.name"
                :disabled="packageMode && !editMode"
                required
              ></v-text-field>
            </v-flex>
            <v-flex xs4 sm4 md4>
              <v-text-field
                v-model="face.patronymic"
                :label="$t('components.clients.faces.form.patronymic')"
                :rules="rules.rule"
                :disabled="packageMode && !editMode"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout form__row row wrap>
            <v-flex xs6 sm6 md6>
              <v-text-field
                v-model="face.inn"
                :label="$t('components.clients.faces.form.inn')"
                :rules="rules.inn"
                :error-messages="errorMessages.inn"
                :disabled="packageMode && !editMode"
                required
              ></v-text-field>
              <!-- <company-search
                v-if="isShowCompnayComponent"
                :dadata="{ inn: face.inn }"
                is-inn
                placeholder=""
                title="ИНН"
                required
                :onChangeCallback="onChangeCallbackCompanySearch"
              ></company-search> -->
              <div class="text-left">
                <a
                  href="https://service.nalog.ru/static/personal-data.html?svc=inn&from=%2Finn.do"
                  target="_blank"
                  >{{$t('components.clients.faces.form.findInn')}}</a
                >
              </div>
            </v-flex>
            <v-flex xs6 sm6 md6>
              <v-text-field
                v-model="face.snils"
                :label="$t('components.clients.faces.form.snils')"
                :error-messages="errorMessages.snils"
                v-mask="'###-###-### ##'"
                :disabled="packageMode && !editMode"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout form__row row wrap>
            <v-flex xs12>
              <v-menu
                ref="day_of_birth"
                v-model="dayOfBirth"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="day_of_birth"
                    :label="$t('components.clients.faces.form.birthday')"
                    prepend-icon="event"
                    v-on="on"
                    v-on:blur="formatDayOfBirth"
                    :rules="rules.day_of_birth"
                    v-mask="'##.##.####'"
                    :disabled="packageMode && !editMode"
                    return-masked-value
                    required
                  ></v-text-field>
                </template>
                <v-date-picker
                  ref="picker"
                  v-model="face.day_of_birth"
                  :max="getMaxBirthDate()"
                  min="1900-01-01"
                  @change="saveDayOfBirth"
                  llocale="ru-ru"
                  first-day-of-week="1"
                  no-title
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>

          <v-layout form__row row wrap>
            <v-flex xs6 sm6 md6>
              <v-text-field
                v-model="face.place_of_birth"
                :label="$t('components.clients.faces.form.placeOfBirththday')"
                :rules="rules.place_of_birth"
                :hint="$t('components.clients.faces.form.strictlyPassport')"
                :disabled="packageMode && !editMode"
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs6 sm6 md6>
              <v-autocomplete
                v-model="face.citizenship"
                :items="citizenshipTypes"
                :label="$t('components.clients.faces.form.citizenship')"
                item-text="name"
                item-value="value"
                :rules="rules.citizenship"
                :disabled="packageMode && !editMode"
                required
              ></v-autocomplete>
            </v-flex>
          </v-layout>

          <v-layout form__row row wrap>
            <v-flex xs6 sm6 md6>
              <v-autocomplete
                v-model="face.document_type"
                :items="documentTypes"
                :label="$t('components.clients.faces.form.documentType')"
                item-text="name"
                item-value="value"
                :rules="rules.document_type"
                :disabled="packageMode && !editMode"
                required
              ></v-autocomplete>
            </v-flex>

            <v-flex xs6 sm6 md6>
              <v-menu
                ref="document_issued_at"
                v-model="documentIssuedAt"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="document_issued_at"
                    :label="$t('components.clients.faces.form.documentIssuedAt')"
                    prepend-icon="event"
                    v-on="on"
                    v-on:blur="formatDocumentIssuedAt"
                    :rules="rules.document_issued_at"
                    v-mask="'##.##.####'"
                    :disabled="packageMode && !editMode"
                    return-masked-value
                    required
                  ></v-text-field>
                </template>
                <v-date-picker
                  ref="picker"
                  v-model="face.document_issued_at"
                  :max="new Date().toISOString().substr(0, 10)"
                  min="1900-01-01"
                  @change="saveDocumentIssuedAt"
                  llocale="ru-ru"
                  first-day-of-week="1"
                  no-title
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>

          <v-layout form__row row wrap v-if="face.document_type == 1">
            <v-flex xs2 sm2 md2>
              <v-text-field
                v-model="face.document_seria"
                :label="$t('components.clients.faces.form.serial')"
                :rules="rules.document_seria"
                :disabled="packageMode && !editMode"
                v-mask="'## ##'"
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs4 sm4 md4>
              <v-text-field
                v-model="face.document_number"
                :label="$t('components.clients.faces.form.number')"
                :rules="rules.document_number"
                :disabled="packageMode && !editMode"
                v-mask="'### ###'"
                required
              ></v-text-field>
            </v-flex>

            <v-flex grow>
              <v-text-field
                v-model="face.document_subdivision_code"
                :label="$t('components.clients.faces.form.code')"
                :rules="rules.document_subdivision_code"
                v-mask="'###-###'"
                :disabled="packageMode && !editMode"
                required
              ></v-text-field>
            </v-flex>
            <!-- <v-flex shrink v-if="!packageMode || editMode">
                            <v-btn @click="getFmsData">найти</v-btn>
                        </v-flex>-->
          </v-layout>

          <v-layout form__row row wrap v-if="face.document_type == 1">
            <v-flex grow>
              <!-- <v-combobox
                                v-model="face.document_issued_by"
                                :items="dadataResponse"
                                label="Кем выдан"
                                hint="Заполняется СТРОГО как в паспорте"
                                :rules="rules.document_issued_by"
                                :disabled="packageMode && !editMode"
                                required
                                v-if="dadataResponse"
                            ></v-combobox>-->

              <v-text-field
                v-model="face.document_issued_by"
                :label="$t('components.clients.faces.form.documentIssuedBy')"
                :hint="$t('components.clients.faces.form.strictlyPassport')"
                :rules="rules.document_issued_by"
                :disabled="packageMode && !editMode"
                required
              ></v-text-field>
            </v-flex>
            <!-- <v-flex shrink>
                            <tips tipId="passportCode" />
                        </v-flex>-->
          </v-layout>

          <v-layout form__row row wrap>
            <v-flex grow>
              <v-text-field
                v-model="face.document_reg_address"
                :label="$t('components.clients.faces.form.regAddress')"
                :hint="$t('components.clients.faces.form.strictlyPassport')"
                :rules="rules.document_reg_address"
                :disabled="packageMode && !editMode"
                required
              ></v-text-field>
            </v-flex>
            <v-flex shrink>
              <tips tipId="passport" />
            </v-flex>
          </v-layout>

          <v-layout form__row row wrap v-if="face.document_type == 2">
            <v-flex xs12>
              <v-text-field
                v-model="face.document_other_data"
                :label="$t('components.clients.faces.form.otherData')"
                :rules="rules.document_other_data"
                :disabled="packageMode && !editMode"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout
            form__row
            row
            wrap
            v-if="face.type == 1 && create && !packageMode"
          >
            <v-flex xs12>
              <v-checkbox
                v-model="face.is_combined_positions"
                :label="$t('components.clients.faces.form.isCombinedPositions')"
                class="mt-0 pt-0"
                :disabled="packageMode && !editMode"
                hide-details
              ></v-checkbox>
            </v-flex>
          </v-layout>

          <v-layout form__row row wrap v-if="create /*&& !packageMode*/">
            <v-flex>
              <v-checkbox
                v-model="face.is_founder"
                :label="$t('components.clients.faces.form.isFounder')"
                class="mt-1 mb-4 pt-0"
                :disabled="packageMode && !editMode"
                hide-details
              ></v-checkbox>
            </v-flex>

            <v-flex v-if="face.is_founder && create">
              <v-text-field
                v-model="face.phone"
                :label="$t('inputs.phone.name')"
                v-mask="'(###) ###-##-##'"
                class="mt-0 pt-0"
                prefix="+7 "
                :rules="rules.phone"
                :disabled="packageMode && !editMode"
                required
              ></v-text-field>
            </v-flex>
            <v-flex shrink v-if="face.is_founder">
              <v-text-field
                v-model="face.percentage"
                :label="$t('components.clients.faces.form.percentage')"
                type="number"
                class="mt-0 pt-0"
                :rules="rules.percentage"
                :disabled="packageMode && !editMode"
                suffix="%"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout form__row form__errors row wrap v-if="errors">
            <v-flex xs12>
              {{$t('components.clients.faces.form.checkErros')}}:
              <strong v-for="(error, idx) in errors" :key="`error_f${idx}`">{{
                error
              }}</strong>
            </v-flex>
          </v-layout>

          <v-layout form__row row wrap v-if="editMode || !packageMode">
            <v-flex xs12>
              <v-btn :loading="faceSaveLoading" :disabled="faceSaveLoading" color="primary" @click="validate" class
                >{{ create ? $t('components.clients.faces.form.saveButton') :$t('components.clients.faces.form.updateButton') }} </v-btn
              >
            </v-flex>
          </v-layout>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { apiCallTrue } from "@/utils/api";
import tips from "@/components/lib/tips";
import rules from "@/utils/data/rules";
import axios from "axios";
import { mask } from "vue-the-mask";
import FaceModel from "@/models/FaceModel";
//import CompanySearch from "@/components/lib/CompanySearch";
import showNotify from "@/services/noty";
import i18n from "@/services/i18n";

export default {
  name: "AddFace",
  directives: { mask },
  components: { tips /*, CompanySearch*/ },
  data: () => ({
    valid: false,
    assignedAt: false,
    assigned_at: "",
    dayOfBirth: false,
    day_of_birth: "",
    documentIssuedAt: false,
    document_issued_at: "",
    dadataResponse: null,
    errors: null,
    errorMessages: {
      snils: "",
      inn: "",
      type: "",
    },
    newErrorMessages: {
      snils: "",
      inn: "",
      type: "",
    },
    // facesTypes: [
    //   { name: "Генеральный директор", value: 1 },
    //   { name: "Главный бухгалтер", value: 2 },
    // ],
    documentTypes: [
      { name: i18n.t("documentTypes.1"), value: 1 },
      { name: i18n.t("documentTypes.2"), value: 2 },
    ],
    citizenshipTypes: [
      { name: i18n.t("citizenshipTypes.643"), value: "643" },
      { divider: true },
      { name: i18n.t("citizenshipTypes.895"), value: "895" },
      //{ name: i18n.t("citizenshipTypes.010"), value: "010" },
      { name: i18n.t("citizenshipTypes.051"), value: "051" },
      { name: i18n.t("citizenshipTypes.112"), value: "112" },
      { name: i18n.t("citizenshipTypes.398"), value: "398" },
      { name: i18n.t("citizenshipTypes.417"), value: "417" },
      { name: i18n.t("citizenshipTypes.762"), value: "762" },
      { name: i18n.t("citizenshipTypes.860"), value: "860" },
      { name: i18n.t("citizenshipTypes.804"), value: "804" },
      { name: i18n.t("citizenshipTypes.896"), value: "896" },
    ],
    faceAssignedTo: [
      { name: i18n.t('components.clients.faces.form.faceAssignedTo.3'), value: 3 },
      { name: i18n.t('components.clients.faces.form.faceAssignedTo.5'), value: 5 },
    ],
    face: {},
    faceSaveLoading: false,
    rules,
    companyDaData: null,
  }),
  props: {
    publicHash: {
      type: String,
      default: "",
    },
    editedFace: {
      type: Object,
    },
    create: {
      type: Boolean,
      default: false,
    },
    ceo: {
      type: String,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    packageMode: {
      type: Boolean,
      default: false,
    },
    agentMode: {
      type: Number,
      default: 0,
    },
    clientCompany: {
      type: Object,
      default: null,
    },
  },
  computed: {
    facesTypes() {
      if (this.isCompanyIP) {
        return [
          { name: i18n.t('components.clients.faces.faceTypeName.1'), value: 1 },
          { name: i18n.t('components.clients.faces.faceTypeName.2'), value: 2 },
        ];
      }
      return [
        { name: i18n.t('components.clients.faces.faceTypeName.default'), value: 1 },
        { name: i18n.t('components.clients.faces.faceTypeName.2'), value: 2 },
      ];
    },
    isCompanyIP() {
      if (this.clientCompany && this.clientCompany.inn) {
        if (new String(this.clientCompany.inn).trim().length == 12) return true;
      }
      /*if (this.companyDaData && this.companyDaData.type == "INDIVIDUAL")
        return true;
      if(this.face.inn && this.face.inn.length == 12)
        return true;*/
      return false;
    },
    isShowCompnayComponent() {
      if (this.create) return true;
      if (this.face && this.face.inn) {
        return true;
      }
      return false;
    },
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.saveFace();
      }
    },
    onChangeCallbackCompanySearch(obj) {
      this.companyDaData = obj;
      if (this.companyDaData) {
        if (!this.face.inn) this.face.inn = this.companyDaData.inn;
        // if (!this.face.surname && !this.face.name && !this.face.patronymic) {
        //   try {
        //     let fio = this.isCompanyIP
        //       ? this.companyDaData.name.full
        //       : this.companyDaData.management.name;
        //     if (fio) {
        //       fio = fio.split(" ");
        //       this.face.surname = fio[0] ? fio[0] : null;
        //       this.face.name = fio[1] ? fio[1] : null;
        //       this.face.patronymic = fio[2] ? fio[2] : null;
        //     }
        //   } catch (e) {
        //     console.warn(e);
        //   }
        // }
        // if (!this.face.type) {
        //   this.face.type = 1;
        // }
        // if (this.isCompanyIP) {
        //   this.face.is_founder = 1;
        // }
        // if (this.isCompanyIP && !this.face.percentage) {
        //   this.face.percentage = 100;
        // }
        //ip Name.full
      }
      console.log("CCCHH", obj);
    },
    async saveFace() {
      this.errors = null;
      const inn = this.agentMode ? this.agentMode : false;
      const method = "POST";
      const data = Object.assign({}, this.face);
      this.faceSaveLoading = true;
      data.snils = data.snils
        ? data.snils.replace("-", "").replace("-", "").replace(" ", "")
        : null;

      if (this.packageMode) {
        let url = "";
        if (this.publicHash) {
          url = this.create
            ? `v1/officials/save-by-hash/${this.publicHash}`
            : `v1/officials/${this.face.id}/save-by-hash/${this.publicHash}`;
        } else {
          url = "v1/validate";
        }
        const params = this.publicHash ? null : { model: "officials", inn };

        await apiCallTrue({
          url,
          data,
          method,
          params,
        })
          .then(() => {
            // if (
            //     !this.face.is_combined_positions &&
            //     !this.face.is_founder &&
            //     this.create
            // ) {
            //     this.addFace();
            // }
            if (this.face.is_combined_positions && this.create) {
              this.updateFacesAndFounders();
            } else {
              this.updateFaces(data);
            }
            // if (this.face.is_founder && this.create) {
            //     this.addFounder();
            // }
          })
          .catch((error) => {            
            this.errors = error.validation;
            this.errorMessages = this.errors ? this.errors : {};
            showNotify('error', error);
          }).finally(()=>{
            this.faceSaveLoading = false;
          });
      } else {
       
        const url = this.create
          ? "v1/officials"
          : `v1/officials/${this.face.id}`;
        const params = inn ? { inn } : {};

        await apiCallTrue({
          url,
          data,
          method,
          params,
        })
          .then(() => {
            if (this.face.is_combined_positions && this.create) {
              this.updateFacesAndFounders();
            } else {
              this.updateFaces(data);
            }
          })
          .catch((error) => {
            showNotify('error', error);
            this.errors = error.validation;
            this.errorMessages = this.errors ? this.errors : {};
          }).finally(()=>{
            this.faceSaveLoading = false;
          });
      }
    },
    // async addFounder() {
    //     const inn = this.agentMode ? this.agentMode : false;
    //     const params = inn ? { inn } : {};
    //     const data = Object.assign({}, this.face);
    //     data.is_legal_person = false;
    //     const method = "POST";

    //     console.log("add founder");

    //     await apiCallTrue({
    //         url: "v1/founders",
    //         data,
    //         method,
    //         params
    //     })
    //         .then(() => {
    //             this.updateFacesAndFounders();
    //         })
    //         .catch(error => (this.errors = error.validation));
    // },
    // async addCombinedPosition() {
    //     const inn = this.agentMode ? this.agentMode : false;
    //     const params = inn ? { inn } : {};
    //     const data = Object.assign({}, this.face);
    //     data.type = 2;

    //     console.log("addCombinedPosition");

    //     await apiCallTrue({
    //         url: "v1/officials",
    //         method: "POST",
    //         data,
    //         params
    //     })
    //         .then(() => {
    //             console.log("aaassseee");
    //             // this.updateFaces();
    //             this.updateFacesAndFounders();
    //         })
    //         .catch(error => console.log(error, "add error"));
    // },
    getFmsData() {
      axios.defaults.headers.common = {
        Authorization: "Token 89b29b1c40ba409aa15e8671be806a1d2e44fb63",
      };
      axios
        .post(
          "https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/fms_unit",
          { query: this.face.document_subdivision_code },
          {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
            },
          }
        )
        .then((response) => {
          this.dadataResponse = response.data.suggestions.map(
            (item) => item.value
          );
        })
        .catch((error) => (this.errors = error));
    },

    addFace() {
      this.errors = null;
      this.errorMessages = Object.assign({}, this.newErrorMessages);
      this.$emit("addFace", this.face);
    },
    updateFaces(face) {
      this.errors = null;
      this.errorMessages = Object.assign({}, this.newErrorMessages);
      this.$emit("updateFaces", face);
    },
    updateFacesAndFounders() {
      this.errors = null;
      this.errorMessages = Object.assign({}, this.newErrorMessages);
      this.$emit("updateFacesAndFounders");
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    saveAssignedAt(date) {
      this.$refs.assigned_at.save(date);
      this.deFormatAssignedAt();
    },
    formatAssignedAt() {
      if (this.assigned_at) {
        this.face.assigned_at = this.assigned_at.split(".").reverse().join("-");
      }
    },
    deFormatAssignedAt() {
      if (this.face.assigned_at) {
        this.assigned_at = this.face.assigned_at.split("-").reverse().join(".");
      }
    },
    saveDayOfBirth(date) {
      this.$refs.day_of_birth.save(date);
      this.deFormatDayOfBirth();
    },
    formatDayOfBirth() {
      if (this.day_of_birth) {
        this.face.day_of_birth = this.day_of_birth
          .split(".")
          .reverse()
          .join("-");
      }
    },
    deFormatDayOfBirth() {
      if (this.face.day_of_birth) {
        this.day_of_birth = this.face.day_of_birth
          .split("-")
          .reverse()
          .join(".");
      }
    },
    saveDocumentIssuedAt(date) {
      this.$refs.document_issued_at.save(date);
      this.deFormatDocumentIssuedAt();
    },
    formatDocumentIssuedAt() {
      if (this.document_issued_at) {
        this.face.document_issued_at = this.document_issued_at
          .split(".")
          .reverse()
          .join("-");
      }
    },
    deFormatDocumentIssuedAt() {
      if (this.face.document_issued_at) {
        this.document_issued_at = this.face.document_issued_at
          .split("-")
          .reverse()
          .join(".");
      }
    },
    closeModal() {
      this.$emit("closeModal");
    },
    getMaxBirthDate() {
      // const now = Date();
      const maxDate = new Date().setFullYear(new Date().getFullYear() - 18);
      return new Date(maxDate).toISOString().substr(0, 10);
    },
  },
  watch: {
    create(val) {
      if (!val) {
        this.face = Object.assign({}, this.editedFace);
        this.deFormatAssignedAt();
        // this.deFormatAssignedTo();
        this.deFormatDayOfBirth();
        this.deFormatDocumentIssuedAt();
      } else {
        this.face = new FaceModel();
        this.assigned_at = "";
        this.assigned_to = "";
        this.day_of_birth = "";
        this.document_issued_at = "";
        this.errors = null;
        this.errorMessages = Object.assign({}, this.newErrorMessages);
        this.$refs.form.resetValidation();
      }
    },
    assignedAt(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    dayOfBirth(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    documentIssuedAt(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
  },
  mounted() {
    if (this.create) {
      this.face = new FaceModel();
    } else {
      this.face = Object.assign({}, this.editedFace);
      this.deFormatAssignedAt();
      this.deFormatDayOfBirth();
      this.deFormatDocumentIssuedAt();
    }
    this.$refs.form.resetValidation();
    this.getMaxBirthDate();
  },
};
</script>
